import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Cabinet } from "@/components/site/Cabinet";
import { Domaines } from "@/components/site/Domaines";
import { Etapes } from "@/components/site/Etapes";
import { Honoraires } from "@/components/site/Honoraires";
import { Contact } from "@/components/site/Contact";
import { Faq } from "@/components/site/Faq";
import { Footer } from "@/components/site/Footer";
import { FloatingRdv } from "@/components/site/FloatingRdv";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Cabinet />
        <Domaines />
        <Etapes />
        <Honoraires />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <FloatingRdv />
    </div>
  );
}
